exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acntTabMenu{margin-top:30px;border-bottom:1px solid rgba(221,221,221,0)}.acntTabMenu a{color:#a7a7a7;background-color:transparent;font-size:16px;border:0;border-bottom:2px solid transparent;box-shadow:none;cursor:pointer}.acntTabMenu a:hover,.acntTabMenu a:focus{background-color:transparent;border:0}.acntTabMenu li.active a{color:#265390;border-bottom:2px solid #265390;font-weight:600}.tabContents{padding:30px;background-color:#ffffff;box-shadow:0px 1px 5px rgba(0,0,0,0.1);margin:30px 0px;margin-top:0px;position:relative;display:block;min-height:calc(100vh - 350px)}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/schema-list/schema-list.component.scss
// module id = 1190
// module chunks = 0 2